<template>
    <v-container grid-list-lg id="services">
        <v-layout row>
            <v-flex class="display-2 text-xs-center my-5">Services we offer</v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm12 md6 v-for="(service) in services">
                <v-card>
                    <v-responsive>
                        <v-img :src=service.img :height=height>
                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-end flexbox>
                                        <span class="headline white--text">{{service.title}}</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>
                    </v-responsive>

                    <v-card-text>
                        <div>
                            <h3 class="headline mb-0">{{service.title}}</h3>
                            <div>{{service.description}}</div>
                        </div>
                    </v-card-text>
                    <!--<v-card-actions><v-btn outline block color="green" @click="getInfo(service.title)">More Info</v-btn></v-card-actions>-->
               </v-card>
           </v-flex>
       </v-layout>
   </v-container>
</template>

<script>
export default {
   name: 'HomeServices',
   methods: {
       getInfo(service) {
           this.$swal('More info for '+service);
       }
   },
   data() {
       return {
           height:'300px', //this.$vuetify.breakpoint.smAndDown ? '300px':'500px',
            services: [
               {title: 'Floor Preparation',img: require('@/assets/prep.jpg'), description:'From new to existing timer flooring.  We have the equipment and know-how to prepare your flooring for the next stage.'},
               {title: 'Polyurethane', img: require('@/assets/polyurethane.jpg'), description:'Once your flooring has been prepared we can apply a polyurethane finish that will last the test of time.  Matt, gloss, you decide.'},
               {title: 'Carpeting', img: require('@/assets/carpeting.jpg'), description:'Prefer the warmth and comfort of carpet? Let us supply and install the carpet to best suit your needs.'},
               {title: 'Vinyl', img: require('@/assets/vinyl.jpg'), description:'For wet areas and areas requiring a smooth, easy to clean surface we can install your style of vinyl'}
           ]
       };
   }
};
</script>

<style scoped></style>
